export default {
  ['popup-title']: '尊敬的参赛者：',
  ['popup-desc1']: '2025年IMA大赛作品提交阶段已结束，评审流程即将启动。',
  ['popup-desc2']:
    '根据大赛规则，同一件作品如已提交至多个赛道，组委会仅保留其中一件进入评审，其余投递将被视为无效。请您知悉。'
}
